module.exports = __webpack_public_path__ + "img/logo.cf1defb2.png";